<script>
  import GroupOpenGraph from '@og/Group.svelte';
  import Group from '@pages/Group.svelte';

  export let data;

  let { params, og, group, sections, recs, recObjects, accessDenied, unknownError, crawler } = data;
  $: ({ params, og, group, sections, recs, recObjects, accessDenied, unknownError, crawler } = data);
</script>

<GroupOpenGraph group={og?.group} />

<Group
  slug={params.slug}
  params={params}
  group={group}
  sections={sections}
  recs={recs}
  recObjects={recObjects}
  accessDenied={accessDenied}
  unknownError={unknownError}
  crawler={crawler} />
